import React, { MouseEvent, useState } from "react"

import { counselApi } from "@shared/apis"
import { useAccount, useLayerPopupContext, useSchedule } from "@shared/contexts"

const MAX_LENGTH = 50

function PartnerQuestion() {
  const { open, close, alert } = useLayerPopupContext()
  const { schedule } = useSchedule()
  const { account } = useAccount()

  const [content, setContent] = useState<string>("")

  const handleOnClick = (event: MouseEvent) => {
    event.preventDefault()

    counselApi
      .post(content, account.viewer!.nickname, schedule!.id)
      .then((res) => {
        handleAlertPopup("문의 등록이 완료되었습니다")
      })
      .catch((err) => {
        handleAlertPopup("에러가 발생하였습니다. 관리자에게 문의해주세요")
      })
  }

  const handleAlertPopup = (message: string) => {
    alert.handleAlert({ contents: message })
    open("ALERT")
  }

  return (
    <React.Fragment>
      <article className="popup" style={{ margin: "-150px 0 0 -250px" }}>
        <div className="titB">
          <h1>파트너 문의하기</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="areaB">
            <textarea
              maxLength={MAX_LENGTH}
              onChange={(e) => {
                e.preventDefault()
                setContent(e.target.value)
              }}
            ></textarea>
            <em>
              {content.length}/{MAX_LENGTH}
            </em>
          </div>
          <p className="txt">
            ※ 가입 및 전문가방송 운영안에 대한 문의만 접수해 주시면 감사
            <br />
            하겠습니다.
            <br />※ 종목상담 접수 및 답변은 금지되어 있습니다.
          </p>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="보내기"
            onClick={(e) => {
              handleOnClick(e)
            }}
          >
            보내기
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default PartnerQuestion
